<template>
  <SidebarWidget>
    <template v-slot:title>
      {{ $t('support.title') }}
    </template>
    <template v-slot:content>
      <p>{{ $t('bulkSend.ifYouNeedAnyHelpUsingTheApp') }}</p>
    </template>
    <template v-slot:cta>
      <BaseLink
        class="w-full"
        variant="secondary"
        size="large"
        href="https://signable.help/"
        target="_blank"
      >
        {{ $t('support.cta') }}
      </BaseLink>
    </template>
  </SidebarWidget>
</template>

<script>
import SidebarWidget from '@/components/library/widgets/SidebarWidget.vue';
import BaseLink from '@/components/library/links/BaseLink.vue';

export default {
  name: 'HelpAndSupportWidget',
  components: { BaseLink, SidebarWidget },
};
</script>

<style scoped>

</style>
